"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth_1 = __importStar(require("@streem/auth"));
const domain_id_1 = require("@streem/domain-id");
const logger_1 = require("@streem/logger");
const api_1 = require("@streem/api");
const toolbox_1 = require("@streem/toolbox");
const SESSION_STORAGE_KEY = 'session-sid';
const SESSION_TIMEOUT_STORAGE_KEY = 'session-timeout';
const UPLOAD_INTERVAL = 30 * 1000; // 30 sec in milliseconds
const SESSION_TIMEOUT_LENGTH = 30 * 60 * 1000; // 30 min in milliseconds
const REGION_MAP = {
    us: api_1.StreemApiAnalyticEventRegion.US,
    ca: api_1.StreemApiAnalyticEventRegion.CA,
    global: api_1.StreemApiAnalyticEventRegion.GLOBAL,
};
class Analytics {
    get sessionSid() {
        let sessionSid = localStorage.getItem(SESSION_STORAGE_KEY);
        const sessionTimeout = localStorage.getItem(SESSION_TIMEOUT_STORAGE_KEY) || '';
        if (!sessionSid || sessionTimeout < new Date().toISOString()) {
            sessionSid = new domain_id_1.SessionId().toString();
            localStorage.setItem(SESSION_STORAGE_KEY, sessionSid);
            this.updateSessionTimeout();
        }
        return sessionSid;
    }
    get configured() {
        return this._configured;
    }
    constructor() {
        this.queuedEvents = [];
        this.logger = (0, logger_1.createLogger)('analytics');
        this._configured = false;
        this.flushQueuedEventsAndEndTimer = () => __awaiter(this, void 0, void 0, function* () {
            yield this.postQueuedEvents();
            if (this.queueTimerId) {
                this.logger.info('clearing timer set for postQueuedEvents');
                window.clearTimeout(this.queueTimerId);
            }
        });
        this.recordEvent = (event) => {
            var _a, _b, _c;
            (0, toolbox_1.invariant)(this.configured, 'Analytics.configure must be called first');
            (0, toolbox_1.invariant)(Object.keys(event).length === 1, 'Events must have one event attached to them');
            try {
                const fullEvent = Object.assign({ sentAt: new Date(), sessionSid: this.sessionSid, appSid: (_a = this.appId) === null || _a === void 0 ? void 0 : _a.toString(), userSid: (_b = this.userId) === null || _b === void 0 ? void 0 : _b.toString(), deviceSid: (_c = this.deviceId) === null || _c === void 0 ? void 0 : _c.toString(), region: this.region }, event);
                this.queuedEvents.push(fullEvent);
            }
            catch (e) {
                this.logger.error(e);
            }
            finally {
                this.updateSessionTimeout();
            }
        };
        this.updateSessionTimeout = () => {
            const now = new Date().getTime();
            const timeout = new Date(now + SESSION_TIMEOUT_LENGTH);
            localStorage.setItem(SESSION_TIMEOUT_STORAGE_KEY, timeout.toISOString());
        };
        this.postQueuedEvents = () => __awaiter(this, void 0, void 0, function* () {
            const events = this.queuedEvents.splice(0, this.queuedEvents.length);
            try {
                if (events.length > 0) {
                    const { failures } = yield api_1.StreemAPI.analytics.recordEvents({ events });
                    if (failures === null || failures === void 0 ? void 0 : failures.length) {
                        // Failures is incorrectly typed
                        const failedEvents = failures.map(failure => {
                            var _a;
                            return ({
                                event: failure.index !== undefined ? events[failure.index] : {},
                                error: (_a = failure.error) === null || _a === void 0 ? void 0 : _a.message,
                            });
                        });
                        this.logger.warn(`Attempted to upload ${events.length} events, but ${failures.length} failed.`, failedEvents);
                    }
                }
            }
            catch (e) {
                this.logger.error(`Attempted to upload ${events.length} events, but an unexpected error occurred`, e);
            }
            finally {
                if (this.queueTimerId) {
                    window.clearTimeout(this.queueTimerId);
                }
                this.queueTimerId = window.setTimeout(this.postQueuedEvents, UPLOAD_INTERVAL);
            }
        });
        window.setTimeout(this.postQueuedEvents, UPLOAD_INTERVAL);
        // Try to post events when we might lose context
        document.addEventListener('visibilitychange', this.postQueuedEvents);
    }
    configure(config) {
        this.appId = new domain_id_1.AppId(config.appId);
        this.region = REGION_MAP[config.regionCode];
        auth_1.default.onAuthStateChanged(user => {
            if ((0, auth_1.isLoginIdentityUser)(user)) {
                // We don't track identified (AKA login identity) users (lid_*), only company/invited users (usr_*)
                return;
            }
            this.userId = (0, auth_1.isExpertUser)(user) ? new domain_id_1.UserId(user.id) : undefined;
            this._inviteId = (0, auth_1.isInvitedUser)(user)
                ? new domain_id_1.InvitationId(user.invitation.invitationSid)
                : undefined;
            this._groupReservationId = (0, auth_1.isGroupReservationUser)(user)
                ? new domain_id_1.GroupReservationId(user.groupReservation.reservationSid)
                : undefined;
        });
        this._configured = true;
    }
    setDeviceId(deviceId) {
        this.deviceId = deviceId;
    }
}
exports.default = new Analytics();
//# sourceMappingURL=analytics.js.map